import { CanvasType, SocketType } from "../types/storeType";
import { CanvasCTX } from "../types/toolsTypes";

export default class Tool {
    canvas: CanvasType = null;
    ctx: CanvasCTX  = null;
    socket: SocketType = null;
    id: string = '';

    constructor(canvas: CanvasType, socket: SocketType, id: string) {
        this.canvas = canvas;
        this.socket = socket;
        this.id = id;
        this.ctx = this.canvas?.getContext('2d');
        this.ctx?.beginPath()
        this.destroyEvents();
    }

    set fillColor(color: string) {
        this.ctx!.fillStyle = color
    }

    set strokeColor(color: string) {
        this.ctx!.strokeStyle = color
    }

    set lineWidths(width: number) {
        this.ctx!.lineWidth = width
    }

    destroyEvents() {
        if(this.canvas) {
            this.canvas.onpointerdown = null;
            this.canvas.onpointerup = null;
            this.canvas.onpointermove = null;
        }
    }


}